<script setup lang="ts">

const props = withDefaults(defineProps<{
    modelValue: number | string;
}>(), {
    modelValue: 1,
})

const emit = defineEmits(["update:modelValue"]);

const updateValue = (event: Event) => {
  const target = event.target as HTMLInputElement;
  emit("update:modelValue", Number(target?.value) || 0); // Convert to number
};

const increment = () => {
  emit("update:modelValue", Number(props.modelValue) + 1);
};

const decrement = () => {
  if (Number(props.modelValue) > 0) {
    emit("update:modelValue", Number(props.modelValue) - 1);
  }
};
</script>
  
  <template>
    <div class="flex items-center bg-white dark:bg-gray-800 border rounded-lg border-gray-300 dark:border-gray-700 hover:shadow-lg w-full overflow-hidden">
      <button @click="decrement" class="bg-gray-600 hover:bg-blue-700 px-1 py-0 text-lg">−</button>
      <input 
        type="number" 
        :value="modelValue" 
        @input="updateValue($event)" 
        :min="0" 
        class="w-full text-center border-none outline-none"
      />
      <button @click="increment" class="bg-gray-600 hover:bg-blue-700 px-1 py-0 text-lg">+</button>
    </div>
  </template>
  
